import { getUserFilterAndTotalCountConnections } from './getUserFilterAndTotalCountConnections'

export const disconnectUserFiltersAndTotalCount = async ({
  editorSdkProxy,
  appApi,
  componentRefs,
  insideRepeaterOnly,
}) => {
  const safeGetComponents = async () => {
    try {
      return await editorSdkProxy.components.get({
        componentRefs,
        properties: ['connections', 'sdkType', 'componentType'],
      })
    } catch {
      return []
    }
  }

  const components = await safeGetComponents()

  const connectionsToDisconnect = (
    await Promise.all(
      components.map(
        async ({ componentRef, connections, sdkType, componentType }) => {
          if (insideRepeaterOnly) {
            const componentIsInsideRepeater =
              await editorSdkProxy.components.isRepeatedComponent({
                componentRef,
              })

            if (!componentIsInsideRepeater) {
              return []
            }
          }

          return getUserFilterAndTotalCountConnections({
            editorSdkProxy,
            appApi,
            sdkType,
            componentType,
            componentRef,
            connections,
          })
        },
      ),
    )
  ).flat()

  await Promise.all(
    connectionsToDisconnect.map(({ componentRef, controllerRef, role }) =>
      editorSdkProxy.controllers.disconnect({
        controllerRef,
        connectToRef: componentRef,
        role,
      }),
    ),
  )

  return connectionsToDisconnect.map(({ componentRef }) => componentRef)
}
